import { utils } from '../../Foundation';

export class ServiceMenu {
    constructor(element) {
        this._refs = {
            el: element,
            items: Array.from(element.querySelectorAll('.service-menu__item'))
        };

        this._props = {
            visibleClass: 'is-visible'
        };

        // Events
        this._refs.items.forEach(item => {    
            if(!this._hasChildren(item)) return false;

            const oLinkItem = item.children[0];
            if(oLinkItem != null) {
                oLinkItem.addEventListener('click', this._onServiceMenuItemClick.bind(this));
            }
        });

        // WCAG Navigational handling
        document.addEventListener('keyup', this._onKeyUp.bind(this));
        document.addEventListener('keydown', this._onKeyDown.bind(this));
    }

    /**
     * Handlers for WCAG manipulation of servicemenu dropdowns
     * @param {Event} e - Event interface
     */
    _onKeyDown(e) {
        let
            oTargetItem = e.target,
            oMenuItem = oTargetItem.closest('li'),
            oDropdown = document.querySelector('.service-menu__item-menu.is-visible') || document.querySelector('.language-selector.is-visible');

        // ARROW_UP, ARROW_DOWN
        if (e.keyCode === 40 || e.keyCode === 38) {
            e.preventDefault();
            e.stopPropagation();

            if (oDropdown === null) {
                oTargetItem.click();
            }

            this._selectMenuItem(e);

            return;
        }
    }

    /**
     * Handlers for WCAG manipulation of servicemenu dropdowns
     * @param {Event} e - Event interface
     */
    _onKeyUp(e) {
        let
            oTargetItem = e.target,
            oMenuItem = oTargetItem.closest('li'),
            oDropdown = document.querySelector('.service-menu__item-menu.is-visible') || document.querySelector('.language-selector.is-visible'),
            oCloseDropdown = document.querySelector('.language-selector.is-visible .language-selector__close-button');
        
        // ESC  
        if(e.keyCode === 27) {
            if(oDropdown !== null && !oCloseDropdown) {
                // Login -> Service menu -> Language should hide when ESC key is pressed
                oDropdown.parentElement.children[0].focus();
                oDropdown.classList.remove('is-visible');
            }
            return; 
        }

        // TAB
        if (e.keyCode === 9) {
            if (oDropdown !== null && oCloseDropdown !== null) {
                if (!oDropdown.contains(oTargetItem)) {
                    // Service menu -> Country should hide when focus is outside container
                    oCloseDropdown.click();
                }
            } else if (oDropdown !== null) {
                if (!oDropdown.contains(oTargetItem)) {
                    // Login -> Service menu -> Language should hide when focus is outside container
                    oDropdown.classList.remove('is-visible');
                }
            }
            return;
        } 
    }

    /**
     * Helper for dynamicly selecting the next element in line
     * @param {Event} keyCode - current keyCode used for activating event chain
     * @param {Event} target - current ActiveElement selected by Event
     */
    _selectMenuItem ({ keyCode, target }) {
        let arrItems = Array.from(document.querySelectorAll('.service-menu__item-menu.is-visible li a'));
        if(arrItems.length === 0) {
            arrItems = Array.from(document.querySelectorAll('.language-selector.is-visible li a'));
        }

        if(!arrItems.length) {
            return;
        }

        utils.getNextActiveElement(arrItems, target, keyCode === 40, !arrItems.includes(target)).focus();
    }

    /**
     * Handler for toggling dropdown within ServiceMenu
     * @param {Event} e - Event Interface
     */
    _onServiceMenuItemClick (e = Event) {
        e.preventDefault();

        const 
            // References
            oItem = e.target,
            oServiceMenuItem = oItem.closest('li'),
            oDropdown = oServiceMenuItem.children[oServiceMenuItem.children.length - 1],
            // Functions
            fnCallback = (e) => {
                if(!oDropdown.contains(e.target) && e.target !== oItem) {
                    oDropdown.classList.remove(this._props.visibleClass);
                    document.removeEventListener('click', fnCallback);
                }                
            };

        if(oDropdown.classList.contains(this._props.visibleClass)) {
            oDropdown.classList.remove(this._props.visibleClass);
            oDropdown.setAttribute("aria-hidden", true);
            document.removeEventListener('click', fnCallback);
        } else {
            oDropdown.classList.add(this._props.visibleClass);
            oDropdown.setAttribute("aria-hidden", false);
            document.addEventListener('click', fnCallback);
        }
    }

    /**
     * _hasChildren
     * Check if an item has a submenu
     * @param {HTMLElement} item - Element to look beneath
     * @returns Boolean
     */
    _hasChildren (item) {
        return item.querySelector('.service-menu__item-menu') !== null;
    }
}